import styled, { css } from "styled-components";
import FilteredPropsInputField from "./FilteredPropsInputField";

export const Label = styled.label`
  margin-top: 1rem;
  width: 100%;
`;
export const InputCover = styled.div`
  width: 100%auto;
  height: 6rem;
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  /* margin: 1rem 0.5rem; */
`;

export const Input = styled(FilteredPropsInputField)`
  font-family: "Avenir-Medium";
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 3rem;
  color: #292929;
  &:focus,
  &:active {
    outline: none;
  }
  /* Autocomplete styles in Chrome*/
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
  }
  ${({ valid }) =>
    valid &&
    css`
      &:focus,
      &:active {
        outline: none;
      }
      /* Autocomplete styles in Chrome*/
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus {
      }
    `}
  ${({ error }) =>
    error &&
    css`
      width: 100%;
      outline: none;
      &:focus,
      &:active {
        outline: none;
      }
      /* Autocomplete styles in Chrome*/
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus {
      }
    `}
`;

export const StyledInlineErrorMessage = styled.div`
  color: rgba(120, 27, 0, 0.9);
  display: block;
  padding: 0.5rem 0.75rem;
  white-space: pre-line;
  font-size: 2rem;
  font-family: "Avenir-Book";
`;

export const Submit = styled.button`
  border-radius: 5px;
  background: #242424;
  padding: 1rem 1.5rem;
  text-decoration: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;
  line-height: 135%;
  letter-spacing: 0.03em;
  color: #fff;
  margin: 2rem 0;
  &:active,
  &:focus,
  &:hover {
    background: #ffff;
    color: #242424;
    border: 2px solid #242424;
    cursor: pointer;
  }

  &:disabled {
    border: none;
    cursor: pointer;
    background-color: rgb(163, 168, 173);
    box-shadow: none;
    color: rgb(255, 255, 255) !important;
    &:hover,
    &:focus {
      cursor: not-allowed;
    }
  }
`;

export const ContactSubmit = styled.button`
  margin: 2rem 0;
  display: inline-block;
  background: #242424;
  padding: 1rem 1.5rem;
  text-decoration: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;
  line-height: 135%;
  letter-spacing: 0.03em;
  color: #fff;

  &:active,
  &:focus,
  &:hover {
    background: #ffff;
    color: #242424;
    border: 2px solid #242424;
    cursor: pointer;
  }

  &:disabled {
    border: none;
    cursor: pointer;
    background-color: rgb(163, 168, 173);
    box-shadow: none;
    color: rgb(255, 255, 255) !important;
    &:hover,
    &:focus {
      cursor: not-allowed;
    }
  }
`;
